//** React Imports
import { createContext, useEffect, useState } from 'react'

// ** Actions & Store
import themeConfig from '@configs/themeConfig'
import { storage } from '../storage'

const ThemeContext = createContext()

// Classes Vuexy controladas por skin — removidas seletivamente para não
// stripar brand-{key} aplicada em applyBrandToDocument.
const SKIN_LAYOUT_CLASSES = ['dark-layout', 'bordered-layout', 'semi-dark-layout']
const THEME_TOKEN_CLASSES = ['theme-light', 'theme-dark']

const resolveThemeClass = (skin) => (skin === 'dark' || skin === 'semi-dark' ? 'theme-dark' : 'theme-light')

const ThemeProvider = ({ children }) => {
  const [skin, setSkin] = useState(() => {
    try {
      const item = storage.get('skin')
      return item !== undefined ? item : themeConfig.layout.skin
    } catch (error) {
      console.log(error)
      return themeConfig.layout.skin
    }
  })

  // ** Return a wrapped version of useState's setter function
  const setTheme = (value) => {
    try {
      // ** Allow value to be a function so we have same API as useState
      const valueToStore = value instanceof Function ? value(skin) : value
      // ** Save to store & local storage
      setSkin(valueToStore)
      storage.set('skin', valueToStore)
    } catch (error) {
      // ** A more advanced implementation would handle the error case
      console.log(error)
    }
  }

  // when user change theme, it will not persist in local storage.
  // example: payment link (only white theme), but when user back to platform, it will be the last theme
  const setNotPersistTheme = (value) => {
    try {
      setSkin(value)
    } catch (error) {
      // ** A more advanced implementation would handle the error case
      console.log(error)
    }
  }

  useEffect(() => {
    const element = window.document.body
    if (!element) return

    SKIN_LAYOUT_CLASSES.forEach((cls) => element.classList.remove(cls))
    THEME_TOKEN_CLASSES.forEach((cls) => element.classList.remove(cls))

    const skinClassMap = {
      dark: 'dark-layout',
      bordered: 'bordered-layout',
      'semi-dark': 'semi-dark-layout'
    }
    if (skinClassMap[skin]) {
      element.classList.add(skinClassMap[skin])
    }

    element.classList.add(resolveThemeClass(skin))
  }, [skin])

  const theme = skin
  return (
    <ThemeContext.Provider value={{ theme, setTheme, setNotPersistTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

export { ThemeProvider, ThemeContext }
